/* Shopify Ajax Cart + Rapid Cart drawer (Zipify OCU fallback). No checkout redirects. */
(() => {
  if (window.sfgA1CartBound) return;
  window.sfgA1CartBound = true;
  let adding = false;
  window.addEventListener('ocu:cart:loaded', () => { window.sfgA1OcuReady = true; });
  const add = async (event) => {
    if (event.type === 'click' && !event.target.closest('[data-sfg-cart] button[type="submit"]')) return;
    const form = event.target.closest('form[data-sfg-cart]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    form.dataset.sfgStatus = 'submitting';
    if (adding) return;
    const button = form.querySelector('button');
    const status = form.querySelector('[role="status"]');
    if (button.disabled) return;
    adding = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    try {
      const endpoint = new URL(form.action);
      endpoint.pathname = endpoint.pathname.replace(/\.js$/, '') + '.js';
      // Gift apps intercept string routes; URL objects can bypass their cart hooks.
      // Line notes (properties[...] inputs, e.g. the gift kit contents) go with the item (30.10.2026).
      const line = { id: Number(form.elements.id.value), quantity: Number(form.elements.quantity.value) };
      const props = {};
      form.querySelectorAll('input[name^="properties["]').forEach((input) => {
        props[input.name.slice(11, -1)] = input.value;
      });
      if (Object.keys(props).length) line.properties = props;
      // One gift kit per cart: a second plan click replaces the kit that is already there.
      const kitIds = (form.dataset.kitIds || '').split(',').filter(Boolean).map(Number);
      if (kitIds.length) {
        const root = endpoint.pathname.replace(/\/cart\/add(\.js)?$/, '');
        const current = await fetch(root + '/cart.js', { credentials: 'same-origin' }).then((r) => r.json());
        const updates = {};
        current.items.forEach((item) => {
          if (kitIds.includes(item.variant_id) && item.variant_id !== line.id) updates[item.key] = 0;
          if (item.variant_id === line.id) line.quantity = 0;
        });
        if (Object.keys(updates).length) {
          await fetch(root + '/cart/update.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
      }
      const response = line.quantity === 0 ? { ok: true, json: async () => ({}) } : await fetch(endpoint.href, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [line] })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || form.dataset.error);
      form.dataset.sfgStatus = 'added';
      // Rapid Cart takes over the theme's cart icon: clicking it opens the drawer with a fresh /cart.js.
      const rapidTrigger = window.__rapiCartConfig && document.querySelector('.wt-cart__trigger');
      if (rapidTrigger && !/\/cart\/?$/.test(window.location.pathname)) {
        rapidTrigger.click();
      } else if (window.sfgA1OcuReady || window.Zipify?.Cart?.cart) {
        window.dispatchEvent(new Event('ocu:cart:open:updated'));
      } else {
        // The same Shopify cart remains usable if the drawer app is unavailable.
        window.location.assign(form.dataset.cartUrl);
      }
    } catch (error) {
      form.dataset.sfgStatus = 'error';
      status.textContent = error.message || form.dataset.error;
    } finally {
      adding = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };
  window.sfgA1Add = add;
  // Theme editor: selecting a FAQ block opens it, and selecting a plan keeps it visible.
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target;
    if (root.matches('details')) root.open = true;
    root.querySelectorAll('details').forEach(el => { el.open = true; });
  });
})();
// Keep the existing help launcher clear of the mobile purchase controls.
(() => {
  let observer;
  function observeOffers() {
    observer?.disconnect();
    const visible = new Set();
    if (!('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
      document.body.classList.toggle('sfg-a1-offer-visible', visible.size > 0);
    }, { threshold: 0.05 });
    document.querySelectorAll('.sfg-a1 #offer, .sfg-a1 #offer2').forEach(el => observer.observe(el));
  }
  document.addEventListener('DOMContentLoaded', observeOffers);
  document.addEventListener('shopify:section:load', observeOffers);
})();
